module.exports = __webpack_public_path__ + "media/applicants/device_signup_5-au-2f061860.webp";